/** Enum de estados de la orden de servicio: Creada, Pendiente, Cancelada, EnProceso, esperas (insumo, servicio tercero, aprobación) y finales Finalizada/Facturada. */
export enum EstadoServicio {
  Creada = 1,
  Pendiente = 2,
  Cancelada = 3,
  EsperandoInsumo = 4,
  Finalizada = 5, // final
  EnProceso = 6,
  EsperandoServicioTercero = 7,
  EsperandoAprobacion = 8,
  Entregado = 9,
  Pausado = 10,
  // Por/A Facturar
  Facturada = 11, // final 1
}
